import type {Temporal} from "@js-temporal/polyfill";
import {formatDayWithDate} from "@/shared/utils/datefunctions";

/**
 * A range of plain dates, rendered as "weekday, date" on both ends with the separation symbol between them.
 * A single-day or open range renders as just the one date.
 * <p>
 * The React counterpart of {@code formatDateRange}, which cannot be used here because it returns the
 * separator as an HTML string — React would escape that into visible markup.
 */
export function DateRange({start, end}: {start: Temporal.PlainDate | null; end: Temporal.PlainDate | null}) {
	if (!start || !end || start.equals(end)) {
		return <>{formatDayWithDate(start ?? end)}</>;
	}

	return (
		<>
			{formatDayWithDate(start)}
			<i className="time-separation-symbol ml-5 mr-5"/>
			{formatDayWithDate(end)}
		</>
	);
}
